import React from 'react'
import { Box, Grid, Typography } from '@mui/material';


const LogDataModal = ({ data }) => {

  return (
    <Box noValidate  sx={{ mt: 2 }} >
      <Grid container columnSpacing={2} rowSpacing={2} >
        <Grid  item xs={12} sm={11} md={11} lg={1110} sx={{mt: 2}}>
          <Typography variant='body2'>{data}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
 
export default React.memo(LogDataModal);
